import React from "react";
import { Grid, IconButton, Tooltip } from "@mui/material";
import {
  Delete,
  RemoveModerator,
  Send,
  VerifiedUser,
  Visibility,
  MonetizationOn,
  Download,
} from "@mui/icons-material";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import { useTranslation } from "react-i18next";
/**
 * @param users
 * @param methods
 * @return {{columns: [{headerName: string, field: string, width: number},{headerName: string, field: string, width: number},{headerName: string, field: string, width: number},{headerName: string, field: string, width: number},{headerName: string, field: string, width: number},null], rows: *[]}}
 */
const AnnualProgressTable = (users = [], methods = {}) => {
  const { openModal, sendToTheInvestor, adminUser } = methods;
  const { t } = useTranslation();

  const handleDownload = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const columns = [
    { field: "id", headerName: "#", width: 50 },
    {
      field: "title",
      headerName: t("fields.title"),
      minWidth: 150,
      flex: 1,
    },
    {
      field: "file",
      headerName: t("fields.viewFile"),
      width: 150,
      renderCell: (props) => {
        const id = props.row.file;
        return (
          <>
            <a href={id} target="_blank">
              {" "}
              <Visibility />
            </a>
          </>
        );
      },
    },
    {
      field: "createdAt",
      headerName: t("fields.createdAt"),
      minWidth: 150,
      flex: 1,
    },
    {
      field: "actions",
      headerName: t("fields.actions"),
      minWidth: 250,
      flex: 1,
      renderCell: (props) => {
        const id = props.row._id;
        const { file } = props.row;
        return (
          <Grid container>
            {adminUser ? (
              <>
                <Grid item>
                  <Tooltip title="Delete" arrow>
                    <IconButton size="small" onClick={() => openModal(id)}>
                      {/* <Delete /> */}
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 11 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.64987 2.74621C1.58545 2.74621 1.53928 2.74621 1.49312 2.74621C1.16653 2.74552 0.839595 2.75138 0.51335 2.74242C0.217077 2.73416 -0.00340522 2.48829 3.98181e-05 2.18974C0.00348485 1.89876 0.225345 1.6677 0.517484 1.6522C0.564681 1.64979 0.611878 1.65048 0.65942 1.65048C3.88673 1.65048 7.11438 1.65048 10.3417 1.65186C10.4392 1.65186 10.5419 1.65496 10.6335 1.68388C10.8908 1.7655 11.0352 2.02169 10.9928 2.29477C10.9549 2.5396 10.7396 2.73691 10.4833 2.74277C10.1567 2.75034 9.8301 2.74587 9.50352 2.74621C9.45735 2.74621 9.41153 2.74621 9.34883 2.74621C9.34883 2.81577 9.34883 2.87018 9.34883 2.92459C9.34883 5.05131 9.34987 7.17803 9.34815 9.3051C9.34746 10.0758 8.89616 10.7107 8.18992 10.9215C8.02387 10.9711 7.84404 10.9945 7.67041 10.9952C6.22212 11.001 4.77383 11.0014 3.32553 10.9972C2.36196 10.9948 1.65159 10.2806 1.65021 9.31577C1.6478 7.18905 1.64952 5.06233 1.64952 2.93526C1.64952 2.87982 1.64952 2.82438 1.64952 2.74621H1.64987ZM3.84849 6.31095C3.84849 6.76618 3.84125 7.22176 3.85331 7.677C3.85641 7.79442 3.89913 7.92424 3.96183 8.02411C4.08585 8.22142 4.34423 8.29442 4.56644 8.22383C4.80345 8.14842 4.94987 7.93767 4.95056 7.6584C4.95228 6.76928 4.95193 5.87982 4.94952 4.9907C4.94952 4.91494 4.93747 4.8354 4.91301 4.76377C4.82826 4.51584 4.57677 4.36605 4.32528 4.4053C4.04658 4.44869 3.85193 4.66391 3.84987 4.9449C3.84608 5.40014 3.84883 5.85572 3.84849 6.31095ZM7.15021 6.33712C7.15021 5.88602 7.15641 5.43492 7.14573 4.98382C7.14298 4.86915 7.10853 4.7438 7.05134 4.64463C6.9318 4.43733 6.67618 4.35399 6.44432 4.42045C6.20662 4.48864 6.04918 4.70317 6.04849 4.97693C6.04642 5.87466 6.04677 6.77273 6.04918 7.67045C6.04918 7.74208 6.06227 7.8168 6.08535 7.88464C6.16975 8.13085 6.42297 8.28202 6.67342 8.24277C6.95178 8.19904 7.14642 7.98416 7.14883 7.70282C7.15297 7.24759 7.14987 6.79201 7.15021 6.33678V6.33712Z"
                          fill="#E0221E"
                        />
                        <path
                          d="M5.49033 1.09401C5.11689 1.09401 4.74311 1.09952 4.37001 1.09229C4.10026 1.08712 3.8815 0.87569 3.85119 0.610194C3.82087 0.345731 3.98864 0.0940095 4.24736 0.0206624C4.29215 0.00792137 4.34038 0.00172303 4.38689 0.00172303C5.12964 0.000689968 5.87239 -0.00206485 6.61514 0.00275608C6.89384 0.00447785 7.11501 0.214533 7.14705 0.485538C7.17806 0.749657 7.01063 1.00241 6.75087 1.07404C6.68576 1.09194 6.61514 1.0947 6.54727 1.09504C6.19519 1.09711 5.84311 1.09608 5.49102 1.09608C5.49102 1.09539 5.49102 1.09504 5.49102 1.09435L5.49033 1.09401Z"
                          fill="#E0221E"
                        />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </Grid>
                <Grid item>
                  <Tooltip title="Send To The Investor" arrow>
                    <IconButton size="small">
                      {/* <Send onClick={() => sendToTheInvestor()} /> */}

                      <svg
                        width="25"
                        height="22"
                        viewBox="0 0 13 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => sendToTheInvestor()}
                      >
                        <path
                          d="M0 5.89605C0.0593654 5.76514 0.166901 5.68246 0.309039 5.61715C4.32553 3.76764 8.341 1.91573 12.3555 0.0626301C12.52 -0.0134592 12.6781 -0.0302348 12.8321 0.068921C12.9858 0.167777 13.0234 0.306475 12.9874 0.467341C12.9671 0.558709 12.9573 0.652173 12.9417 0.744438C12.7578 1.83725 12.5739 2.93036 12.3897 4.02317C12.1984 5.15672 12.0061 6.28997 11.8151 7.42352C11.7174 8.00318 11.6122 8.58224 11.5288 9.16339C11.4775 9.52077 11.1905 9.61813 10.8737 9.52047C9.26677 9.02529 7.6544 8.54329 6.04373 8.0571C5.80085 7.98371 5.55796 7.91121 5.29607 7.83273C7.11943 5.89275 8.93364 3.96236 10.7478 2.03197C10.7424 2.02597 10.7373 2.01998 10.7319 2.01399C10.7044 2.03107 10.6753 2.04634 10.6501 2.06552C8.35423 3.7991 6.05798 5.53237 3.7641 7.26805C3.68947 7.32437 3.62875 7.33216 3.53852 7.3049C2.46858 6.97897 1.39797 6.65454 0.325661 6.33461C0.168937 6.28788 0.0732738 6.19651 0.000339231 6.07518V5.89575L0 5.89605Z"
                          fill="#FD3B1F"
                        />
                        <path
                          d="M4.74992 8.42578C5.48741 8.64836 6.20862 8.86614 6.94339 9.08812C6.84128 9.21124 6.74664 9.32477 6.65233 9.43861C6.26968 9.89844 5.88635 10.358 5.50505 10.8187C5.406 10.9385 5.28218 11.0134 5.10883 10.9978C4.8829 10.9775 4.74382 10.831 4.74314 10.6111C4.74144 9.91342 4.74246 9.21543 4.7428 8.51775C4.7428 8.49199 4.74653 8.46622 4.74992 8.42608V8.42578Z"
                          fill="#FD3B1F"
                        />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </Grid>
              </>
            ) : (
              <Grid item>
                <Tooltip title="Download Annual Report" arrow>
                  <IconButton size="small">
                    <Download onClick={() => handleDownload(file)} />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
          </Grid>
        );
      },
    },
  ];

  const rows =
    users.length === 0
      ? []
      : [
          ...users.map((user, id) => ({
            id: id + 1,
            title: user.title,
            file: user.file,
            createdAt: user.createdAt,
            _id: user._id,
          })),
        ];

  return { rows, columns };
};

export default AnnualProgressTable;
